// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { login } from 'client/actions/user';
import { loginAndProvision } from 'client/actions/enterprise/user';

import LoginPage from './loginPage';

const mapStateToProps: Object = ({ siteConfigs, translations }, ownProps) => {
  const query = _.get(ownProps, 'location.query', {});
  const { code, redirect, id } = query;
  return {
    code,
    redirect,
    siteConfigs,
    translations,
    id, // partner user id
  };
};

export default connect(mapStateToProps, { loginAndProvision, login })(LoginPage);
